export default "__VITE_ASSET__B88uMQTz__"